import React, { useEffect } from "react";
import tippy from "tippy.js";

import { Icon } from ".";

interface Props {
  container: HTMLElement;
}

const TooltipKentico: React.FC<Props> = ({ container }) => {
  const {
    contentTitle, // tooltip - contentTitle
    contentText, // tooltip - contentText
    contentLinkUrl, // tooltip - contentLinkUrl
    contentLinkText, // tooltip - contentLinkText
    contentLinkIsExternal, // tooltip - contentLinkIsExternal
    tooltipText, // tooltip - tooltipText (text next to icon)
    tooltipDarkBg, // tooltip - tooltipDarkBg (color theme)
  } = container.dataset;

  const getTooltipOnDarkBg = () => {
    return (
      <span className="tooltip-kentico group mr-1 flex-row items-center hover:cursor-pointer">
        {tooltipText && (
          <span className="mr-1 inline border-b border-dashed border-b-white leading-5 text-white group-hover:border-b-grey-30 group-hover:text-grey-30">
            {tooltipText}
          </span>
        )}
        <Icon
          name="tooltip"
          viewBox="0 0 24 24"
          alt="tooltip"
          svg={
            '<path d="M12 19.5C7.85775 19.5 4.5 16.1423 4.5 12C4.5 7.85775 7.85775 4.5 12 4.5C16.1423 4.5 19.5 7.85775 19.5 12C19.5 16.1423 16.1423 19.5 12 19.5ZM12 18C13.5913 18 15.1174 17.3679 16.2426 16.2426C17.3679 15.1174 18 13.5913 18 12C18 10.4087 17.3679 8.88258 16.2426 7.75736C15.1174 6.63214 13.5913 6 12 6C10.4087 6 8.88258 6.63214 7.75736 7.75736C6.63214 8.88258 6 10.4087 6 12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V15.75H11.25V11.25Z"/>'
          }
          className="inline h-6 w-6 fill-grey-darkMode-contentTertiary group-hover:fill-grey-30"
        />
      </span>
    );
  };

  const getTooltipOnLightBg = () => {
    return (
      <span className="tooltip-kentico group mr-1 flex-row items-center hover:cursor-pointer">
        {tooltipText && (
          <span className="mr-1 inline border-b border-dashed border-b-grey-200 leading-5 text-grey-200 group-hover:border-b-red-corporate group-hover:text-red-corporate">
            {tooltipText}
          </span>
        )}
        <Icon
          name="tooltip"
          viewBox="0 0 24 24"
          alt="tooltip"
          svg={
            '<path d="M12 19.5C7.85775 19.5 4.5 16.1423 4.5 12C4.5 7.85775 7.85775 4.5 12 4.5C16.1423 4.5 19.5 7.85775 19.5 12C19.5 16.1423 16.1423 19.5 12 19.5ZM12 18C13.5913 18 15.1174 17.3679 16.2426 16.2426C17.3679 15.1174 18 13.5913 18 12C18 10.4087 17.3679 8.88258 16.2426 7.75736C15.1174 6.63214 13.5913 6 12 6C10.4087 6 8.88258 6.63214 7.75736 7.75736C6.63214 8.88258 6 10.4087 6 12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V15.75H11.25V11.25Z"/>'
          }
          className="inline h-6 w-6 fill-grey-80 group-hover:fill-red-corporate"
        />
      </span>
    );
  };

  useEffect(() => {
    tippy(container, {
      allowHTML: true,
      content: `
      <div class="mb-2 break-words font-semibold text-[16px]">${contentTitle}</div>
        <div class="break-words">${contentText}</div>
        <a href="${contentLinkUrl}" target="${
        contentLinkIsExternal ? "_blank" : "_self"
      }" class="inline-block">
          ${contentLinkText}
        </a>
      </div>
      `,
      trigger: "click",
      hideOnClick: true,
      interactive: true,
      arrow: true,
      theme: "kb",
      zIndex: 1070,
    });
  }, []);

  return tooltipDarkBg ? getTooltipOnDarkBg() : getTooltipOnLightBg();
};

export default TooltipKentico;
